import { render, staticRenderFns } from "./AssigneeView.vue?vue&type=template&id=2ecd5bd6&scoped=true"
import script from "./AssigneeView.vue?vue&type=script&lang=js"
export * from "./AssigneeView.vue?vue&type=script&lang=js"
import style0 from "./AssigneeView.vue?vue&type=style&index=0&id=2ecd5bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd5bd6",
  null
  
)

export default component.exports